import { Family } from 'src/clients/hooks/useFamily';
import { TemplateWithoutSections } from 'src/data-capture/hooks/templates/useTemplates';
import { Client } from 'src/users';

export type NewSuitabilityData = {
  flowId: string;
  adviceFiles: SelectedFile[];
  optimiseAdviceReadability: boolean;
  template?: TemplateWithoutSections;
  reportFormat: ReportFormat;
  feeDocuments: SelectedFile[];
  supportDocuments: SelectedFile[];
  highlightedElement: string | undefined;
  isLoading?: boolean;
} & (
  | {
      isFamily: true;
      family?: Family;
    }
  | {
      isFamily: false;
      client?: Client;
    }
);

export type StepProps = {
  data: NewSuitabilityData;
  setData: React.Dispatch<React.SetStateAction<NewSuitabilityData>>;
  onNext: () => void;
  filter?: string;
  searchBar?: React.ReactNode;
};

export const STEP_ORDER = [
  'client',
  'advice',
  'documents',
  'template',
  'support',
  'processing',
] as const;

export type StepId = (typeof STEP_ORDER)[number];

export type SelectedFile = {
  id: string;
  name: string;
  fileId: number;
  summary?: string;
};

export type ReportFormat = 'LETTER' | 'REPORT';

export type AdviceDto = {
  id: string;
  clientId: string;
  dataExportTemplateId?: string | null;
  dataUploadFileId?: string | null;
  content?: string | null;
  adviceClass?: string | null;
  summary?: string | null;
  createdAt?: string | null;
};
